import { render, staticRenderFns } from "./TestQuery.vue?vue&type=template&id=32dc9ffd&scoped=true&"
import script from "./TestQuery.vue?vue&type=script&lang=js&"
export * from "./TestQuery.vue?vue&type=script&lang=js&"
import style0 from "./TestQuery.vue?vue&type=style&index=0&id=32dc9ffd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc9ffd",
  null
  
)

export default component.exports